var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1336,
    height: 2206,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fx0",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%",
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.101961,
    intercept: 0
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "6.88516 6.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 268,
    width: 1336,
    height: 2206
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883.204 300.256C722.741 300.256 562.278 361.471 439.848 483.9 194.99 728.759 194.99 1125.75 439.848 1370.61 615.909 1546.67 763.695 1751.01 883.204 1983.62 1002.71 1751.01 1150.5 1546.67 1326.56 1370.61 1571.42 1125.75 1571.42 728.759 1326.56 483.9 1204.13 361.471 1043.67 300.256 883.204 300.256ZM214 268 1550 268 1550 2474 214 2474Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.50517,
    y: -3.5,
    width: 344.007,
    height: 134
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 339,
    height: 126
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "translate(-214 -268)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    filter: "url(#fx0)",
    transform: "matrix(3.9941 0 0 4 205 1973)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    transform: "translate(7.10543e-15 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 41.2131C-5.24698e-15 18.4517 18.4517-5.24698e-15 41.2131-1.0494e-14 57.5792-3.49798e-15 73.9453-2.62843 90.3115-7.88529 85.0546 8.48083 82.4262 24.847 82.4262 41.2131 82.4262 63.9744 63.9744 82.4262 41.2131 82.4262 18.4517 82.4262 0 63.9744 0 41.2131Z",
    stroke: "#2D7223",
    strokeWidth: 3.04792,
    strokeMiterlimit: 8,
    fill: "#61B346",
    fillRule: "evenodd",
    transform: "matrix(-2.42405 -0.510988 -2.42405 0.510988 369.351 73.7195)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M1326.56 483.9C1571.42 728.759 1571.42 1125.75 1326.56 1370.61 1150.5 1546.67 1002.71 1751.01 883.204 1983.62 763.695 1751.01 615.91 1546.67 439.849 1370.61 194.99 1125.75 194.99 728.759 439.849 483.9 684.707 239.042 1081.7 239.042 1326.56 483.9Z",
    stroke: "#2D7223",
    strokeWidth: 64.1667,
    strokeMiterlimit: 8,
    fill: "#61B346",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.848 376.034C828.29 377.562 782.55 405.039 765.504 448.315 748.707 490.742 756.464 542.689 787.325 576.789 788.179 582.156 782.419 581.396 778.811 582.826 678.868 610.864 591.957 681.753 544.277 773.964 522.736 814.766 509.691 859.628 503.238 905.21 502.187 911.246 501.136 917.283 500.085 923.319 495.39 918.01 490.695 912.701 486 907.394 488.811 922.951 492.424 938.501 494.738 954.064 492.277 968.213 489.814 982.363 487.353 996.512 491.632 991.846 496.408 985.241 500.391 981.732 507.683 1021.98 515.131 1062.72 532.059 1100.25 575.065 1201.46 663.927 1282.02 769.106 1314.32 773.8 1314.72 775.782 1317.26 775.883 1321.9 778.257 1331.61 783.909 1340.52 790.016 1347.94 774.819 1393.83 798.756 1448.54 842.604 1468.76 881.7 1487.68 932.923 1476.83 960.199 1442.77 982.93 1415.87 990.35 1376.29 977.051 1343.43 983.054 1335.67 986.962 1326.4 988.734 1316.76 1088.77 1288.17 1175.47 1216.59 1222.62 1123.84 1241.54 1087.26 1253.52 1047.5 1260.91 1007.09 1262.46 999.815 1264.02 992.538 1265.58 985.261 1270.76 991.435 1275.94 997.608 1281.11 1003.78 1278.22 987.417 1274.46 971.042 1272.12 954.683 1276.08 936.207 1280.04 917.731 1284 899.254 1277.79 906.345 1271.58 913.438 1265.37 920.53 1258.41 880.512 1251.16 840.074 1234.76 802.643 1193.38 703.361 1108.18 623.39 1006.24 588.935 996.79 585.709 987.223 582.829 977.55 580.351 978.055 576.136 973.26 571.368 977.373 568.194 996.234 543.992 1003.34 512.003 999.066 481.843 995.187 445.033 973.763 409.769 940.682 392.277 920.406 380.977 897.017 375.514 873.848 376.034ZM878.554 487.396C885.932 488.071 888.012 496.437 887.072 502.618 886.874 513.052 885.105 523.721 880.068 532.979 872.083 521.413 867.185 506.531 869.771 492.554 871.624 489.608 875.035 487.448 878.554 487.396ZM882.76 641.875C892.803 641.918 903.755 642.384 912.653 643.303 920.186 644.03 925.515 644.717 932.884 645.939 1013.32 659.086 1087.58 705.693 1134.33 772.491 1160.31 809.347 1178.16 851.993 1186.2 896.312 1188.58 903.751 1195.31 909.607 1203.08 910.713 1214.64 924.5 1226.2 938.287 1237.76 952.074 1226.27 965.205 1214.77 978.336 1203.28 991.467 1193.07 991.726 1184.96 1000.99 1185.07 1011 1171.91 1073.64 1139.57 1132.26 1092.41 1175.68 1042.16 1222.5 976.054 1252.03 907.513 1257.32 904.554 1257.5 897.926 1257.97 893.573 1258.1 816.977 1260.91 739.721 1233.92 681.903 1183.51 669.974 1173.21 658.88 1161.96 648.619 1150.01 646.768 1147.73 642.732 1142.98 640.216 1139.66 609.689 1100.81 588.789 1054.47 579.727 1005.96 577.297 997.401 569.134 991.092 560.194 991.257 548.602 978.153 537.012 965.048 525.418 951.944 537.288 938.373 548.74 924.025 560.855 910.923 571.954 910.525 580.683 900.449 580.481 889.55 583.916 873.138 588.681 857.014 594.585 841.324 595.487 839.016 597.778 833.039 599.407 829.371 631.905 752.08 697.616 689.847 776.249 660.96 810.217 648.255 846.512 641.919 882.76 641.875Z",
    fill: "#2D7223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938 585 938 605.836C920.081 603.036 901.747 601.553 883.081 601.553 864 601.553 845.251 603.036 827.083 606L827 585.165 861.097 585.083 896.686 585.083Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 501.294C960 557.38 901.631 576.103 895.2 578L893.634 578C895.365 577.093 897.096 575.938 898.745 574.536 912.101 562.989 928.095 540.802 928.095 500.717 928.095 461.539 898.168 447.352 878.052 447.352 857.936 447.352 828.833 464.921 828.833 496.593 828.833 536.1 847.713 560.844 863.542 574.536 865.108 575.938 866.84 577.093 868.571 578L862.635 578C856.37 576.35 798 559.607 798 494.613 798 438.115 847.053 417 878.052 417 886.379 417.083 960 419.392 960 501.294Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216 1025C1187.28 1153.39 1085.51 1254.65 956.583 1283.02 954.107 1283.6 951.548 1284.09 949.072 1284.58 927.695 1288.78 905.574 1291 882.959 1291 859.518 1291 836.655 1288.61 814.617 1284.17 812.058 1283.68 809.582 1283.1 807.106 1282.53 679.255 1253.49 578.476 1152.65 550 1025Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217 878 550 878C578.81 744.738 685.794 640.191 820.35 614.941 822.826 614.446 825.303 614.034 827.779 613.621 845.94 610.568 864.514 609 883.5 609 902.074 609 920.399 610.485 938.148 613.373 940.707 613.786 943.183 614.199 945.66 614.694 1080.71 639.696 1188.11 744.408 1217 878Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949 1292.5 949 1307.29C949 1317.65 940.774 1326 930.574 1326L833.344 1326C823.226 1326 815 1317.65 815 1307.29L815 1292C837.046 1296.51 859.831 1298.85 883.111 1298.85 905.65 1298.93 927.613 1296.76 949 1292.5Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943 1378.99C943 1407.42 920.506 1438 884.253 1438 848.247 1438 826 1406.59 826 1377.42 826 1351.81 844.127 1336.32 848.247 1333.08L858.463 1333.08C854.509 1341.7 847.752 1358.94 847.752 1375.85 847.752 1399.22 863.572 1416.87 884.5 1416.87 904.522 1416.87 922.072 1399.22 922.072 1379.08 922.072 1362.42 911.031 1342.78 904.934 1333L917.375 1333C921.66 1335.65 943 1349.49 943 1378.99Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.297 850.62C483.331 881.724 467.198 926.929 473.262 970.321 477.536 1003.25 494.834 1033.42 518.364 1056.72 522.438 1059.23 528.557 1057.16 533.448 1057.83 769.948 1057.83 1006.45 1057.83 1242.95 1057.83 1267.79 1036.53 1285.98 1007.35 1291.76 975.167 1300.71 929.145 1282.26 879.956 1247.02 849.052 1243.85 843.845 1238.06 845.171 1232.82 845.104 994.974 845.104 757.133 845.104 519.29 845.104 517.626 846.942 515.962 848.781 514.297 850.62ZM1209.18 918.686C1221.48 938.191 1221.94 964.712 1209.1 984.091 991.391 984.091 773.681 984.091 555.97 984.091 544.883 964.165 544.549 938.532 556.019 918.686 773.74 918.686 991.461 918.686 1209.18 918.686Z",
    fill: "#2D7223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253 951.5C1253 971.331 1246.78 987.377 1239.8 999.226L1239.8 999.226C1236.3 1005.23 1232.64 1010.01 1229.48 1013.63 1228.38 1014.94 1227.35 1016.01 1226.42 1017L538.468 1017C538.297 1016.84 538.127 1016.67 538.042 1016.51 535.146 1012.97 531.227 1007.78 527.393 1001.12L527.393 1001.12C520.749 989.434 514.36 973.141 514.02 953.31 513.593 932.163 520.067 914.883 527.052 902.54 530.716 895.957 534.549 890.773 537.53 887.152 537.871 886.74 538.212 886.329 538.468 886L1226.42 886C1227.53 887.152 1228.72 888.468 1229.99 890.032 1233.15 893.735 1236.73 898.59 1240.14 904.514 1246.95 916.117 1253 931.998 1253 951.5Z",
    fill: "#61B346",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.a9d5ff2e6902d3286942403c7eb0f444.svg";
export { ForwardRef as ReactComponent };